import { ReactElement } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

export interface ProtectedRouteProps {
  element: ReactElement;
  allowedRoles?: string[];
  requiresApiKey?: boolean;
  user: {
    roles?: Array<{ name: string }>;
  } | null;
  hasApiKey?: boolean;
  loginPath: string;
  unauthorizedPath: string;
}

const ProtectedRoute = ({ 
  element,
  allowedRoles,
  requiresApiKey,
  user,
  hasApiKey,
  loginPath,
  unauthorizedPath,
}: ProtectedRouteProps) => {
  const location = useLocation();

  if (!user) {
    return <Navigate to={loginPath} state={{ from: location }} replace />;
  }

  // Check role-based access - either admin or has specific role
  if (allowedRoles && allowedRoles.length > 0) {
    const hasRole = user.roles?.some(role => role?.name && allowedRoles.includes(role.name));
    if (!hasRole) {
      return <Navigate to={unauthorizedPath} replace />;
    }
  }

  // Check API key requirements for all users, including admins
  if (requiresApiKey && !hasApiKey) {
    return <Navigate to={unauthorizedPath} replace />;
  }

  return element;
};

export default ProtectedRoute; 